import { Skeleton } from '@/components/ui/skeleton';

export function ConfirmArrivalSkeleton() {
  return (
    <div className="space-y-6 py-4">
      <div className="grid gap-6 sm:grid-cols-2">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="h-16 w-full" />
        ))}
      </div>
      <Skeleton className="h-40 w-full" />
    </div>
  );
}
